import SubBrandPage from "@/components/SubBrandPage";
import { SupplyCatalogView } from "@/components/supply/SupplyCatalogView";
import { PortfolioGallery } from "@/components/supply/PortfolioGallery";
import { SafeBoundary } from "@/components/SafeBoundary";

export default function TheSocialSupply() {
  return (
    <SubBrandPage meta={{
      slug: "social-supply",
      tag: "Customize",
      mood: "light",
      title: "The Social Supply.",
      tagline: "Custom event details designed to make celebrations feel personal, intentional, and completely yours.",
      heroImg: "/media/social-supply.jpg",
      overview: "Graduation 2027, children's birthdays, ready-to-party custom products, a DIY print shop, and custom labels — designed in-house for your celebration.",
      ctaLabel: "Start an Order Request",
      ctaHref: "/book?service=supply",
      sections: [],
      faqs: [
        { q: "Is submitting the form a confirmed order?", a: "No. It's an order request. We review it and approve or adjust pricing, then you sign your agreement and pay 100% through Stripe. Your design proof follows, and production begins only after you approve your final proof." },
        { q: "How much lead time do you need?", a: "Standard orders need at least 14 calendar days. Orders with a custom backdrop, Grad Signature and Birthday Bash need 21 days. Executive packages need 30 days. We use the longest lead time that applies. Rush orders are not available." },
        { q: "How do revisions work?", a: "Two revision rounds are included. Additional rounds are $15 each. Once you approve your final proof, the design is final — later changes may require an additional fee or a new order and may affect your completion date." },
        { q: "Pickup, delivery or shipping?", a: "Pickup is free. Local delivery is $10. Shipping is calculated after your order is reviewed, and shipping time is in addition to production time." },
      ],
    }}>
      <SafeBoundary name="portfolio-gallery"><PortfolioGallery /></SafeBoundary>
      <SupplyCatalogView />
    </SubBrandPage>
  );
}
